//import { Box, IconButton, useTheme } from "@mui/material";
import { useContext,useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import { ColorModeContext, colorMotifs } from "../../theme";
import InputBase from "@mui/material/InputBase";
import { Box, Divider, IconButton, ListSubheader, Menu, MenuItem, useTheme } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import SearchIcon from "@mui/icons-material/Search";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ConnString from "../../ConnString.js";

 
 const Connstring2 = ConnString.connstring;

//import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined"; // ✅ Menu icon


const Topbar = ({ setIsSidebar }) => { // ✅ Accept the prop from App.js
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const motif = theme.palette.motif;
  const topbar = { background: motif.panel, border: motif.border, text: motif.text, muted: motif.muted, input: dark ? motif.panelStrong : motif.paper, icon: motif.main };
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState(sessionStorage.getItem("userEmail"));
  const [selectedCompany, setSelectedCompany] = useState(sessionStorage.getItem("compName"));
  const [userFullName, setuserFullName] = useState(sessionStorage.getItem("userFullName"));
  const [compName, setcompName] = useState(sessionStorage.getItem("compName"));
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);


// useEffect(() => {
//      const interval = setInterval(async () => {
//         // const res = await fetch("http://localhost:3001/api/check-session", {
//          const res = await fetch(`${Connstring2}/api/check-session`, {
//             credentials: "include",
//         });
//         const data = await res.json();

//         if (!data.loggedIn) {
//             sessionStorage.clear();
//             window.location.href = "/";
//         }
//     }, 60000); // check every 1 minute

//     return () => clearInterval(interval);
// }, []);

  useEffect(() => {
  const email = userEmail;
  const company = compName;
  //const userFullName = sessionStorage.getItem("userFullName");

  setUserEmail(email || "");
  setSelectedCompany(company || "");
  // console.log("✅ App opened by:", email, "with company:", company);
  }, []);


  const handleLogout = async () => {
      try {
          // const response = await fetch("http://localhost:3001/api/logout", {
           const response = await fetch(`${Connstring2}/api/logout`, {
              method: "POST",
              credentials: "include",
          });
          const result = await response.json();

          if (result.success) {
              sessionStorage.clear();
              navigate("/");
          } else {
              alert("Logout failed.");
          }
      } catch (error) {
          console.error("Logout error:", error);
      }
  };

  const openSettingsMenu = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const closeSettingsMenu = () => {
    setSettingsAnchorEl(null);
  };

  const goToChangePassword = () => {
    closeSettingsMenu();
    navigate("/App/settings/change-password");
  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}
     sx={{ minHeight: 56, background: `${topbar.background} !important`, color: topbar.text, borderBottom: `1px solid ${topbar.border}`, boxShadow: dark ? "0 4px 18px rgba(0,0,0,.22)" : "0 4px 18px rgba(21,89,140,.10)" }}>
      {/* LEFT SIDE: MENU + SEARCH BAR */}
    
          <Box display="flex" alignItems="center" >
          User: <strong style={{ fontSize: "10px" }}>{userFullName}</strong>
          
           &nbsp;&nbsp;&nbsp;Company: <strong style={{ fontSize: "10px" }}>{compName}</strong>
        </Box>
   
      {/* RIGHT SIDE: ICONS */}
      <Box display="flex" alignItems="center">
        
        <Box display="flex" alignItems="center" gap={1}>
        {/* <IconButton onClick={() => setIsSidebar((prev) => !prev)}>
          <MenuOutlinedIcon />
        </IconButton> */}
        <Box display="flex" backgroundColor={topbar.input} borderRadius="10px" border={`1px solid ${topbar.border}`}>
          <InputBase sx={{ ml: 2, flex: 1, color: topbar.text, "& input::placeholder": { color: topbar.muted, opacity: 1 } }} placeholder="Search" />
          <IconButton type="button" sx={{ p: 1, color: topbar.icon }}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
        
        <IconButton onClick={colorMode.toggleColorMode} sx={{ color: topbar.icon }}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}

          {/* {theme.palette.mode === "light" ? (
            <LightModeOutlinedIcon />
          ) : (
            <DarkModeOutlinedIcon />
          )} */}

        </IconButton>
        <Tooltip title="Notifications">
        <IconButton sx={{ color: topbar.icon }}>
          <NotificationsOutlinedIcon />
        </IconButton>
        </Tooltip>
        <IconButton onClick={openSettingsMenu} sx={{ color: topbar.icon }}>
          <SettingsOutlinedIcon />
        </IconButton>
        <Menu
          anchorEl={settingsAnchorEl}
          open={Boolean(settingsAnchorEl)}
          onClose={closeSettingsMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <ListSubheader sx={{ bgcolor: "transparent", color: "text.secondary", fontWeight: 800, lineHeight: "34px" }}>Color motif</ListSubheader>
          {Object.entries(colorMotifs).map(([key, option]) => (
            <MenuItem key={key} selected={colorMode.colorMotif === key} onClick={() => colorMode.setColorMotif(key)}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, width: "100%" }}>
                <Box sx={{ width: 18, height: 18, borderRadius: "50%", bgcolor: option.swatch, border: "2px solid", borderColor: "background.paper", boxShadow: "0 0 0 1px rgba(0,0,0,.18)" }} />
                <Box sx={{ flex: 1 }}>{option.label}</Box>
                {colorMode.colorMotif === key && <CheckOutlinedIcon fontSize="small" color="primary" />}
              </Box>
            </MenuItem>
          ))}
          <Divider />
          <MenuItem onClick={goToChangePassword}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LockResetOutlinedIcon fontSize="small" />
              Change Password
            </Box>
          </MenuItem>
        </Menu>
          <Tooltip title="User Profile">
            <IconButton sx={{ color: topbar.icon }}>
              <PersonOutlinedIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Log Out">
         <IconButton sx={{ color: topbar.icon }}>
          <LogoutOutlinedIcon onClick = {handleLogout} />
        </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Topbar;
